module.exports = __webpack_public_path__ + "static/media/S (74).e2ed215e.jpg";